 

import app from 'flarum/forum/app';
import  { extend, override }  from 'flarum/common/extend';
//import CommentPost from 'flarum/forum/components/CommentPost';

import CommentPost from 'flarum/forum/components/CommentPost';
import Post from 'flarum/forum/components/Post.tsx';
import DiscussionComposer from 'flarum/forum/components/DiscussionComposer';
import WelcomeHero from 'flarum/forum/components/WelcomeHero';

import Search from 'flarum/forum/components/Search';

import Button from 'flarum/common/components/Button';
import NotificationList from 'flarum/forum/components/NotificationList';

import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import PostControls from 'flarum/forum/utils/PostControls';

import listItems from 'flarum/common/helpers/listItems';

import Dropdown from 'flarum/common/components/Dropdown';

import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import DiscussionList from 'flarum/forum/components/DiscussionList';


import DiscussionPageResolver from 'flarum/forum/resolvers/DiscussionPageResolver';
import Discussion from 'flarum/common/models/Discussion';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import IndexPage from 'flarum/forum/components/IndexPage';

import DiscussionsSearchSource from 'flarum/forum/components/DiscussionsSearchSource';
import DiscussionHero from 'flarum/forum/components/DiscussionHero';
import PostQuoteButton from 'flarum/mentions/forum/fragments/PostQuoteButton';
import LinkButton from 'flarum/forum/components/LinkButton';
import Link from 'flarum/forum/components/Link';
import TagsPage from 'flarum/tags/forum/components/TagsPage';
import PostStream from 'flarum/forum/components/PostStream';
import PostStreamScrubber from 'flarum/forum/components/PostStreamScrubber';
import extractText from 'flarum/common/utils/extractText';
import TextEditor from 'flarum/forum/components/TextEditor';

import PostUser from 'flarum/forum/components/PostUser';
import UserCard from 'flarum/forum/components/UserCard';
import UserPage from 'flarum/forum/components/UserPage';
import TagHero from 'flarum/tags/forum/components/TagHero';
import PostMentionedNotification from 'flarum/mentions/forum/components/PostMentionedNotification';
import { truncate } from 'flarum/common/utils/string';
import  MoreDiscussions from './../../../../../vendor/datlechin/flarum-more-discussions/js/src/forum/components/MoreDiscussions'
import sortTags from 'flarum/tags/common/utils/sortTags';
import classList from 'flarum/common/utils/classList';
import UserBadgesPage from './../../../../../vendor/fof/badges/js/src/forum/components/UserBadgesPage'; // 确保路径指向该组件
import BadgeCard from './../../../../../vendor/fof/badges/js/src/forum/components/BadgeCard'; // 确保路径指向该组件
import tagsLabel from './../../../../../vendor/flarum/tags/js/src/common/helpers/tagsLabel'; // 确保路径指向该组件
import PostStreamState from 'flarum/forum/states/PostStreamState';
import PrivateComposing from './../../../../../vendor/fof/byobu/js/src/forum/pages/PrivateComposing';
import canStartPrivateDiscussion from './../../../../../vendor/fof/byobu/js/src/forum/helpers/canStartPrivateDiscussion';
var isPC=()=> {
  var userAgentInfo = navigator.userAgent;
  var Agents = ["Android", "iPhone",
              "SymbianOS", "Windows Phone",
               "iPod","iPad"];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
      }
  }
  return flag;
};

window.isPC=isPC();

//import DiscussionsUserPage from 'flarum/forum//components/DiscussionsUserPage';
app.initializers.add('tohsakarat/my', () => {
    
    
    app.cdnHost="https://cdn.klezik-insi.de"
    
    // 修复1：让 discussion 请求带上正确的 near 参数，避免多余的 posts 请求

    // 修复1：让 discussion 请求带正确的 near 参数，拿到对应位置的帖子
    // 修复1：让 discussion 请求带正确的 near 参数，拿到对应位置的帖子
  extend(DiscussionPage.prototype, 'requestParams', function (params) {
    const rawNear = m.route.param('near');
    const near = rawNear === 'reply' ? 0 : (parseInt(rawNear) || 0);
    if (near > 0) params.page = { near };
    return params;
  });
  // 修复2：discussion 返回后立即渲染 + 滚动，不等后续 posts 请求
  extend(DiscussionPage.prototype, 'show', function (result, discussion) {
    if (this.stream && !this.discussion) {
      this.discussion = discussion;
      app.current.set('discussion', discussion);
      app.current.set('stream', this.stream);
      m.redraw(); // 立即渲染，PostStream oncreate 挂载
      setTimeout(() => m.redraw(), 0); // 触发 PostStream onupdate → needsScroll=true → 执行滚动
    }
  });
    extend(UserCard.prototype, 'infoItems', function (items) {
        // 1. 检查原插件是否已经添加了 'cardBadges' 这个 item
        if (items.has('cardBadges')) {
          const user = this.attrs.user;
          if (!user) return;
    
          const badgeName = user.attribute('primaryBadgeName');
          if (!badgeName) return;
    
          // 2. 获取原插件生成的 VNode (即那个 Link 标签)
          const badgeLinkVnode = items.get('cardBadges');
          
          // 3. 非侵入式修改：拦截并在 attrs 中强行注入 title 属性
          if (badgeLinkVnode && badgeLinkVnode.attrs) {
            badgeLinkVnode.attrs.title = badgeName;
          }
        }
      });
   //================信息流，首屏三贴 翻页三贴==============
     override(DiscussionListState.prototype, 'loadPage', function(original, page) {
        // 在它组装分页 offset 之前，强行把写死的 20 篡改成 10
        this.pageSize =5; 
        
        // 放行，让它继续执行原来的请求逻辑
        return original(page);
    });

     PostStreamState.loadCount = 5
  /*
    //================帖子流翻页，更宽松================
   override(PostStream.prototype, 'loadPostsIfNeeded', function(original, top = window.pageYOffset) {
    const marginTop = this.getMarginTop();
    const viewportHeight = $(window).height() - marginTop;
    const viewportTop = top + marginTop;
    
    // --- 关键修改：将 300 改为更大值，比如 1000 ---
    // 这样当帖子还在视口下方 1000 像素时就开始预读数据
    const loadAheadDistance = 1000; 
    // 向前加载逻辑
    if (this.stream.visibleStart > 0) {
      const $item = this.$('.PostStream-item[data-index=' + this.stream.visibleStart + ']');
      if ($item.length && $item.offset().top > viewportTop - loadAheadDistance) {
        this.stream.loadPrevious();
      }
    }
    // 向后加载逻辑
    if (this.stream.visibleEnd < this.stream.count()) {
      const $item = this.$('.PostStream-item[data-index=' + (this.stream.visibleEnd - 1) + ']');
      if ($item.length && $item.offset().top + $item.outerHeight(true) < viewportTop + viewportHeight + loadAheadDistance) {
        this.stream.loadNext();
      }
    }
  });
  */
  
    //================回帖提示加原贴内容================
  override(PostMentionedNotification.prototype, 'excerpt', function(original) {
    // 直接从后端的附加属性中读取实时序列化的内容
    const replyContent = this.attrs.notification.data.attributes.replyContent;
    
    if (replyContent) {
      return <>
                <span class="notification-replyContent" >{replyContent}</span>
                 <span class="notification-originalPost" >{original()}</span>
            </>
    }
    
    // 如果由于某种原因（比如帖子被硬删除）没查到，降级显示原贴
    return original();
  });
  
    //================在自己创主页增加发布按钮================
    extend(UserPage.prototype, 'sidebarItems', function (items) {
      // 确保当前页面用户信息已加载，并且当前访问者已登录
      if (!this.user || !app.session.user) return;
    
      // 核心判断：当前查看的用户，是否是当前登录的用户自己
      const isActor = app.session.user === this.user;
    
      if (isActor) {
        // ==========================================
        // 逻辑 A：如果是自己的主页，注入【发布讨论】按钮
        // ==========================================
        const canStartDiscussion = app.forum.attribute('canStartDiscussion');
    
        items.add(
          'newDiscussion',
          <Button
            icon="fas fa-edit"
            className="Button Button--primary IndexPage-newDiscussion" // 复用首页的样式类，保持 UI 一致
            itemClassName="App-primaryControl"
            onclick={() => {
              // 点击直接唤起发布框
              app.composer.load(DiscussionComposer, { user: app.session.user });
              app.composer.show();
            }}
            disabled={!canStartDiscussion}
          >
            {app.translator.trans(`core.forum.index.${canStartDiscussion ? 'start_discussion_button' : 'cannot_start_discussion_button'}`)}
          </Button>,
          110 // 优先级 110，确保排在导航菜单上方
        );
    
      } else {
        // ==========================================
        // 逻辑 B：如果是别人的主页，注入【发送私信】按钮
        // ==========================================
        
        // 检查当前登录用户是否有权限给该目标用户发私信
        if (canStartPrivateDiscussion(this.user)) {
          // 实例化你在第二个文件中使用的私信撰写组件
          let composing = new PrivateComposing(this.user);
    
          // 将私信组件注入到侧边栏中
          items.add(
            'start_private',
            composing.component(),
            110 // 使用同样的优先级，保证按钮在别人主页时也出现在最上方
          );
        }
      }
    });
  
  //================在首页增加手机版额外发布按钮================
    extend(IndexPage.prototype, 'view', function (vnode) {
    const user = app.session.user;

    // 构建你要的 DOM 结构，外层 div 包裹 Button 组件
    const footerNavigator = (
      <div className="Navigation ButtonGroup App-backControl footer-navigator">
        <Button
          // Button 组件自带 'Button' 类，如果传入 icon 也会自带 'hasIcon' 类
          // 所以我们只需要补齐剩下的静态类名，并加上动态的红点 'new' 类名
          className={classList('Button Button--icon Navigation-drawer', { new: user?.newNotificationCount() })}
          onclick={(e) => {
            e.stopPropagation();
            app.drawer.show();
          }}
          icon="fas fa-bars"
          aria-label={app.translator.trans('core.lib.nav.drawer_button') || '打开导航抽屉'}
        />
      </div>
    );

    // 将生成的组件塞入 IndexPage 视图的最末尾
    if (vnode && Array.isArray(vnode.children)) {
      vnode.children.push(footerNavigator);
    }
  });
    
    //================tag界面隐去tag自己================
    extend(DiscussionListItem.prototype, 'infoItems', function (items) {
        if (!items.has('tags')) return;
    
        const tags = this.attrs.discussion.tags();
        const currentTagSlug = m.route.param('tags');
    
        if (currentTagSlug && tags && tags.length) {
          // 1. 从当前帖子的标签中找到当前路由对应的标签实例
          const currentTag = tags.find(tag => tag.slug() === currentTagSlug);
    
          if (currentTag) {
            // 2. 利用 Flarum 模型自带的方法获取父标签实例（如果没有父标签则返回 false/undefined）
            const parentTag = typeof currentTag.parent === 'function' ? currentTag.parent() : null;
            
            // 获取两者的 ID 以便对比
            const currentTagId = currentTag.id();
            const parentTagId = parentTag ? parentTag.id() : null;
    
            // 3. 过滤掉自身以及它的父标签
            const filteredTags = tags.filter(tag => {
              const tagId = tag.id();
              return tagId !== currentTagId && tagId !== parentTagId;
            });
    
            // 4. 如果过滤后数组有变化，则重新渲染
            if (filteredTags.length !== tags.length) {
              if (filteredTags.length > 0) {
                items.replace('tags', tagsLabel(filteredTags));
              } else {
                // 如果连带父标签一起过滤完后，一个标签都不剩了，直接移除组件
                items.remove('tags');
              }
            }
          }
        }
    });
  
  
  
  //================修复看不到访客的bug    ================
   extend(UserPage.prototype, 'loadUser', function (original,username) {
          app.store.find('users', username, {bySlug: true ,include: 'latestProfileViews,latestProfileViews.viewer,latestProfileViews.viewedUser' }).then(user => {
        m.redraw();
    });
    return original;
  })
  
    // 彻底移除帖子底部的勋章显示，不管后端发没发数据，这里直接不挂载组件
  extend(CommentPost.prototype, 'footerItems', function (items) {
    if (items.has('badges')) {
      items.remove('badges');
    }
       if (items.has('liked')) {
      items.remove('liked');
    }
    
  });
     //    ================用户页勋章即使修改反馈   ================
   const originalRequest = app.request.bind(app);

  app.request = function (options) {
    const promise = originalRequest(options);

    if (options.url && options.url.includes('/user-badges/') && options.url.endsWith('/toggle')) {
      if (options.body?.action === 'toggleFavorite') {
        promise.then((response) => {
          if (response?.success) {
            // 从当前页面组件数据中取得用户模型
            const user = app.current?.data?.user;
            if (user) {
              // 强制从后端拉取最新用户数据并刷新 UI
              app.store.find('users', user.id()).then(() => {
                m.redraw();
              });
            }
          }
        });
      }
    }

    return promise;
  };
  
  
  
   //================首屏自动翻页   ================
// 1. 初始化时增加一个标志位，用于记录是否已经进行过“首屏自动翻页”
  extend(DiscussionList.prototype, 'oninit', function () {
    this.hasAutoLoadedOnce = false;
  });

  // 2. 绑定滚动事件
  extend(DiscussionList.prototype, 'oncreate', function () {
    this.infiniteScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.infiniteScrollHandler, { passive: true });
  });

  // 3. 每次组件更新（重新渲染DOM）后触发
  extend(DiscussionList.prototype, 'onupdate', function () {
    const state = this.attrs.state;

    // 如果状态不存在，或者还在转圈圈（初始化加载中），什么都不做
    if (!state || state.isInitialLoading()) return;

    // 如果初始化加载完毕，且这是第一次刷出列表
    if (!this.hasAutoLoadedOnce) {
      this.hasAutoLoadedOnce = true; // 立刻上锁，确保整个生命周期内只自动翻这一次

      // 如果有下一页，且当前没有在加载下一页
      if (state.hasNext() && !state.isLoadingNext()) {
        // 【关键】必须用 setTimeout 包裹
        // 因为 onupdate 处于 Mithril 框架的渲染周期内，直接调用 loadNext() 会触发重绘，导致框架报错
        //翻两页
        setTimeout(() => {
          state.loadNext();
          /*翻页如果需要两次
           setTimeout(() => {
             state.loadNext();
           }, 1000);*/
           
        }, 0);
      }
    }
  });

  // 4. 卸载时清理事件
  extend(DiscussionList.prototype, 'onremove', function () {
    if (this.infiniteScrollHandler) {
      window.removeEventListener('scroll', this.infiniteScrollHandler);
    }
  });

  // 5. 滚动监听逻辑（你之前需要的到底部自动加载）
  DiscussionList.prototype.onScroll = function () {
    const state = this.attrs.state;

    if (!state || !state.hasNext() || state.isInitialLoading() || state.isLoadingNext()) return;

    const loadMoreContainer = document.querySelector('.DiscussionList-loadMore');
    
    if (loadMoreContainer) {
      const rect = loadMoreContainer.getBoundingClientRect();
      // 当 Load More 区域接近视口底部（增加 50px 缓冲）时触发加载
      if (rect.top <= window.innerHeight + 50) {
        state.loadNext();
      }
    }
  };
    
    

   // 覆写滚动方法，正确更新帖子进度
    let isTicking = false;

   override(PostStream.prototype, 'updateScrubber', function (original, top = window.pageYOffset) {
    if (isTicking) return;
    isTicking = true;

    window.requestAnimationFrame(() => {
      const marginTop = this.getMarginTop();
      const viewportHeight = window.innerHeight - marginTop;
      const viewportTop = window.pageYOffset + marginTop;

      const items = document.querySelectorAll('.PostStream .PostStream-item[data-index]');
      
      let visible = 0;
      let period = '';
      let indexFromViewPort = null;

      // 🌟 全新极速穿透法：只测首尾，拒绝核弹级遍历
      // 🌟 实用主义极致版：直接抓取必定有高度的核心内容块
    const getRealRect = (el) => {
      const rect = el.getBoundingClientRect();
    
      // 如果它自身就有高度（没有被 display: contents 影响），直接返回
      if (rect.height > 0) return rect;
    
      // 遇到黑洞时，直接穿透去拿 .Post-body 的尺寸
      const postBody = el.querySelector('.Post-body');
      if (postBody) {
        return postBody.getBoundingClientRect();
      }
    
      // 兜底方案（比如某些连 body 都没有的系统通知或彻底隐藏的废贴）
      return rect;
    };
      for (let i = 0; i < items.length; i++) {
        const el = items[i];
        
        const rect = getRealRect(el);
        const elTop = rect.top + window.pageYOffset;
        const height = rect.height || 1; 

        if (elTop + height < viewportTop) continue;
        if (elTop > viewportTop + viewportHeight) break;

        const visibleTop = Math.max(0, viewportTop - elTop);
        const visibleBottom = Math.min(height, (viewportTop + viewportHeight) - elTop);
        const visiblePost = visibleBottom - visibleTop;

        if (indexFromViewPort === null) {
          const currentIndex = parseFloat(el.getAttribute('data-index'));
          indexFromViewPort = currentIndex + (visibleTop / height);
        }

        if (visiblePost > 0) {
          visible += visiblePost / height;
        }

        const time = el.getAttribute('data-time');
        if (time) period = time;
      }

      if (indexFromViewPort !== null) {
        this.stream.index = indexFromViewPort + 1;
        this.stream.visible = visible;
      } else {
        this.stream.index = this.stream.count();
      }

      if (period) {
        this.stream.description = dayjs(period).format(
          extractText(app.translator.trans('core.lib.datetime_formats.scrubber'))
        );
      }

      isTicking = false;
    });
  });
    extend(PostStream.prototype, 'view', function (vdom) {
        if (!vdom || !Array.isArray(vdom.children)) return;
    
        const newChildren = [];
        let currentGroup = [];
        let currentAuthorId = null;
    
        // 辅助函数：提取真实的 PostStream-item 节点
        const getPostItemVnode = (vnode) => {
          if ((vnode.tag === '[' || vnode.tag === '<') && Array.isArray(vnode.children)) {
            return vnode.children.find(c => c && c.attrs && c.attrs.className && c.attrs.className.includes('PostStream-item'));
          }
          return vnode;
        };
    
        // 辅助函数：优雅地向 vnode 追加 className，避免重复和覆盖
        const addClassToVnode = (vnode, extraClass) => {
          const target = getPostItemVnode(vnode);
          if (target && target.attrs) {
            // 使用 Set 防止重复添加同一个 class
            const classes = new Set((target.attrs.className || '').split(' ').filter(Boolean));
            extraClass.split(' ').forEach(c => classes.add(c));
            target.attrs.className = Array.from(classes).join(' ');
          }
        };
    
        // 辅助函数：清算当前累积的同一作者帖子组
        const flushGroup = () => {
          if (currentGroup.length === 0) return;
    
          if (currentGroup.length === 1) {
            // 孤立帖子：【去掉包裹层】，直接追加 isolated 标识后推入
            addClassToVnode(currentGroup[0], 'PostStream-item--isolated');
            newChildren.push(currentGroup[0]);
          } else {
            // 连续帖子：打上 首、中、尾 class
            currentGroup.forEach((vnode, index) => {
              if (index === 0) {
                addClassToVnode(vnode, 'PostStream-item--authorStart');
              } else if (index === currentGroup.length - 1) {
                addClassToVnode(vnode, 'PostStream-item--authorEnd');
              } else {
                addClassToVnode(vnode, 'PostStream-item--authorMiddle');
              }
            });
    
            // 只有短且连续的帖子才会被包裹，且 wrapper 上带有 PostStream-item
            newChildren.push(
              <div className="PostStream-item PostStream-authorGroup PostStream-authorGroup--continuous">
                {currentGroup}
              </div>
            );
          }
    
          currentGroup = [];
        };
    
        vdom.children.forEach((vnode) => {
          if (!vnode) return;
    
          const targetVnode = getPostItemVnode(vnode);
          const attrs = targetVnode ? targetVnode.attrs : vnode.attrs;
    
          // 判断是否为活人发贴
          if (attrs && attrs['data-type'] === 'comment' && attrs['data-id']) {
            const post = app.store.getById('posts', attrs['data-id']);
            const authorId = post && post.user() ? post.user().id() : null;
    
            if (authorId !== null) {
              const htmlContent = post.contentHtml() || '';
              const textLength = htmlContent.replace(/<[^>]*>?/gm, '').trim().length;
              
              // 如果超过 1000 字，触发长帖截断逻辑
              if (textLength > 1000) {
                flushGroup(); // 把前面的帖子先结算掉
                
                // 长贴：【去掉包裹层】，直接打上 longPost 和 isolated 标签后推入
                addClassToVnode(vnode, 'PostStream-item--longPost PostStream-item--isolated');
                newChildren.push(vnode);
    
                currentAuthorId = authorId;
                return;
              }
    
              // 正常字数的短贴走连贴逻辑
              if (currentAuthorId === authorId) {
                currentGroup.push(vnode);
              } else {
                flushGroup();
                currentAuthorId = authorId;
                currentGroup.push(vnode);
              }
              return;
            }
          }
    
          // 非活人发贴，结算活人贴并直接推入
          flushGroup();
          currentAuthorId = null; 
          newChildren.push(vnode);
        });
    
        flushGroup(); // 收尾
        vdom.children = newChildren; 
      });





    extend(TagHero.prototype, 'view', function (vnode) {
      const tag = this.attrs.model;
      if (!tag || !vnode) return;
    
      // 1. 动态添加 Tag 相关的 Class 到 header 上
      const slugClass = `tag-${tag.slug()}`;
      vnode.attrs.className = classList(vnode.attrs.className, slugClass);
    
      // 2. 注入 heroPic 节点到 header 的最前面
      // 确保 children 是数组，以便我们使用 unshift
      if (!vnode.children) {
        vnode.children = [];
      } else if (!Array.isArray(vnode.children)) {
        vnode.children = [vnode.children];
      }
    
      // 使用 JSX 语法插入 div（Flarum 开发环境通常支持 JSX）
      // 插入到最前面，确保它作为背景层不会遮挡 .container
      vnode.children.unshift(
        <div className="heroPic"></div>
      );
      
      // 如果你不用 JSX，可以写成：
      // vnode.children.unshift(m('div', { className: 'heroPic' }));
    });
    extend(TagsPage.prototype, 'tagTileView', function (vnode, tag) {
      if (vnode && vnode.attrs) {
        const slugClass = `tag-${tag.slug()}`;
        vnode.attrs.className = vnode.attrs.className 
          ? `${vnode.attrs.className} ${slugClass}` 
          : slugClass;
      }
    });
    
    extend(TagHero.prototype, 'view', function (vnode) {
  if (vnode && vnode.attrs && this.attrs.model) {
    const slugClass = `tag-${this.attrs.model.slug()}`;
    vnode.attrs.className = vnode.attrs.className 
      ? `${vnode.attrs.className} ${slugClass}` 
      : slugClass;
  }
 }); 
    //===========搜索框直接跳转========
  extend(IndexPage.prototype, 'viewItems', function (items) {
        items.add('search', <Search state={app.search} />, -16);
 
    });


    document.referrerPolicy = "no-referrer";




  extend(DiscussionHero.prototype, 'items', function (items,query) {
   
         if(!window.copyTextToClipboard)window.copyTextToClipboard=function(text) {
            let fallbackCopyTextToClipboard = (text) => {
              var textArea = document.createElement('textarea');
              textArea.value = text;
            
              // Avoid scrolling to bottom
              textArea.style.top = '0';
              textArea.style.left = '0';
              textArea.style.position = 'fixed';
            
              document.body.appendChild(textArea);
              textArea.focus();
              textArea.select();
            
              document.execCommand('copy');
            
              document.body.removeChild(textArea);
            };
            if (!navigator.clipboard) {
                fallbackCopyTextToClipboard(text);
                return;
            }
            navigator.clipboard.writeText(text).then(function() {
                alert('复制成功！'+text);
            }, function(err) {
                alert('复制失败，请手动输入: '+text);
            });
        }
       
    if(!app.current?.data?.discussion?.data?.id)return
        items.add('id',
           
                <span icon="fas fa-right" 
                
                  onclick={()=>{
                    window.copyTextToClipboard( app.current?.data?.discussion?.data?.id)
                    }}
                
                >
                <i class="fas fa-right" />
                  {app.translator.trans('ID = '+ app.current?.data?.discussion?.data?.id)}
                </span>
               ,-15
                
             
        );
 
    });
        extend(DiscussionListItem.prototype, 'oncreate', function() {
        // 获取当前组件的根 DOM 元素
        const element = this.element;
    
        // 添加右键菜单（contextmenu）事件监听
        element.addEventListener('contextmenu', (e) => {
          // 1. 拦截浏览器默认的右键菜单
          e.preventDefault();
    
          // 2. 查找你指定的按钮选择器：.DiscussionListItem-controls > button
          // 注意：这里使用 querySelector 查找当前条目内部的按钮
          const controlButton = element.querySelector('.DiscussionListItem-controls button');
    
          // 3. 如果找到了按钮，则触发它的点击事件
          if (controlButton) {
            controlButton.click();
          }
        });
      });
      extend(DiscussionsSearchSource.prototype, 'view', function (items,query) {
   

        let exp = /^[+-]?\d*(\.\d*)?(e[+-]?\d+)?$/
         
        //console.log(exp.test(query))
       
        //console.log(items)
       //// console.log(items)
      // console.log(query);
       if(m.route.param().q)query=query.split(' ').filter((e)=>e.indexOf(':')==-1).join(' ')+' '+m.route.param().q.split(' ').filter((e)=>e.indexOf(':')!=-1).join(' ');
       
       items[1]=<li>
        <LinkButton icon="fas fa-search" href=
        
        
        {
        app.current.data.routeName.indexOf('tag')!=-1 || 
        app.current.data.routeName.indexOf('following')!=-1 ||
        app.current.data.routeName.indexOf('private')!=-1
        ?
        app.route(app.current.get('routeName'), {  ...m.route.param(),q: query.trimEnd() }):
         app.route('index',{q: query.trimEnd()})
        
        
        }>
          {app.translator.trans('core.forum.search.all_discussions_button',  { query })}
        </LinkButton>
      </li>
      
       if(!exp.test(query))return;
       
        items.unshift(
            <li>
                <LinkButton icon="fas fa-right" href={app.route('discussion', { id: query })}>
                  {app.translator.trans('tohsakarat-tags-filter.forum.index_page.filter_tags.link-button')+' '+query}
                </LinkButton>
             </li>
        );
 
    });
    

    

    extend(DiscussionPageResolver.prototype,"canonicalizeDiscussionSlug",function (slug) {
      //console.log("触发路由转换"+slug)
      return slug.split('-')[0];
        
    }

    )
    
    extend(Discussion.prototype,"slug",function (slug) {
      //console.log("触发路由转换"+slug)
      return  slug.split('-')[0];
        
    }

    )
    
    
    
   // console.log('------------------DiscussionListParams------------------')
  //  console.log(DiscussionListParams)
      //  setInterval(function () { debugger }, 100); 
        //window.setInterval(function () { debugger }, 100); 
    
         //--------------------------如果屏蔽，完全不渲染-------------------------
        extend(DiscussionListItem.prototype, 'elementAttrs', function (attrs) {
            //  console.log(this.attrs.discussion.user&&this.attrs.discussion.user() && this.attrs.discussion.user().ignored&& this.attrs.discussion.user().ignored())
            
            // console.log(attrs)
            if(this.attrs.discussion.user&&this.attrs.discussion.user() && this.attrs.discussion.user().ignored&& this.attrs.discussion.user().ignored())attrs.className+=' byIgnoredUser'
            return  attrs;
        
        })
        
    extend( MoreDiscussions.prototype, 'view', function (attrs) {
        
        console.log('============more discussions==========')
        console.log(attrs);
        return attrs;
        
    })
    
        extend( MoreDiscussions.prototype, 'oninit', function (attrs) {
        
        console.log('============more discussions========oaoaoaoaoa==')
        console.log(attrs);
        
    })

     //--------------------------Route--------------------------
        Search.MIN_SEARCH_LEN=1;
    
     //app.routes.user.path='/:username/discussions'
     app.routes.user= { path: '/u/:username/discussions', component:DiscussionPage },
     
     app.route.discussion = (discussion, near) => {
      return app.route(near && near !== 1 ? 'discussion.near' : 'discussion', {
        id: discussion.slug().split('-')[0],
        near: near && near !== 1 ? near : undefined,
      });
    }
   
     
     
     
     ////////////////////////////////////////////////////////////////////////////////////
     //--------------------------帖子--------------------------

     extend(CommentPost.prototype, 'refreshContent', function (vnode) {
         

        
       //--------------------------回车处理--------------------------
    
           //this.element.innerHTML = this.element.innerHTML.replaceAll('<br>\n','\n<span class="fromBR"></span >') 
           //console.log('找到BR！！')
         //  console.log(this.element.querySelectorAll('br'))
         
          const brs = Array.from(this.element.querySelectorAll('br'));

            brs.forEach(br => {
              // 已经被删掉的跳过
              if (!br.parentNode) return;
            
              let next = br.nextSibling;
              let isMultiple = false; // 新增：用来记录是否遇到了连续的 br
              
              while (next) {
                if (next.nodeType === Node.TEXT_NODE && next.nodeValue.trim() === '') {
                  // 删掉无用的空白节点
                  const temp = next.nextSibling;
                  next.remove();
                  next = temp;
                } else if (next.nodeName === 'BR') {
                  // 遇到了连续的 br，标记为 true，并把多余的 br 删掉
                  isMultiple = true; 
                  const temp = next.nextSibling;
                  next.remove();
                  next = temp;
                } else {
                  // 连续被打断，跳出循环
                  break;
                }
              }
            
              // 根据是否合并了多个 br，输出对应的 span 结构
              if (isMultiple) {
                br.outerHTML = '<span class="fromBR multipleBR"></span>';
              } else {
                br.outerHTML = '<span class="fromBR"></span>';
              }
            });
            
         return vnode;
    
     });
       
     
     //--------------------------发帖自动跳tag/字符串处理--------------------------
         
     extend(DiscussionComposer.prototype, 'oninit', function (vnode) {
            setTimeout(()=>{$('.DiscussionComposer-changeTags')[0].click()},500)//选tag customized
             return vnode;

     }); 
   
    // 1. 拦截 content: 捕获并从原有流中移除 Signature
      extend(CommentPost.prototype, 'content', function (vdom) {
        if (!Array.isArray(vdom)) return;
    
        // 寻找前置插件注入的 vnode，根据原插件的特征 (className="Post-signature") 进行匹配
        const index = vdom.findIndex(
          (vnode) => vnode && vnode.attrs && vnode.attrs.className === 'Post-signature'
        );
    
        if (index !== -1) {
          // 成功捕获：将其从原 content 数组中删除，并暂存到当前组件实例中
          this.extractedSignature = vdom.splice(index, 1)[0];
        } else {
          this.extractedSignature = null;
        }
      });
    
      // 2. 拦截 view: 将提取出的 Signature 追加到 action 和 footer 之后
      extend(CommentPost.prototype, 'view', function (vdom) {
        // 只有在成功捕获到 Signature 的情况下才执行追加
        if (this.extractedSignature && vdom && vdom.children) {
          // Flarum 的 Post.js 默认视图结构通常是: <article> 包裹着一层 <div>
          // 这层 <div> 内包含了 {content}, <aside className="Post-actions">, <footer className="Post-footer">
          // 因此我们需要尝试把组件放到内层 <div> 的 children 末尾，紧跟在 footer 之后
          const innerContainer = vdom.children.find(
            (child) => child && child.tag === 'div'
          );
    
          if (innerContainer && Array.isArray(innerContainer.children)) {
            innerContainer.children.push(this.extractedSignature);
          } else if (Array.isArray(vdom.children)) {
            // Fallback: 如果 Flarum 结构未来有变找不到内层 div，则降级直接追加到根节点末尾
            vdom.children.push(this.extractedSignature);
          }
        }
      });
     /*
   
    extend(DiscussionComposer.prototype, 'data', function (data) {

        if(data.content.length>2000){
            alert('长度超限。请不要把正文放在首楼！')
            data.title='';data.content='';
            app.composer.editor.insertBetween(1999,app.composer.data().content.length,'')//删除超出的内容
            console.log('删除超出内容')
        }else{
             data.content= data.content.replaceAll('（🧐注：网易云和b站直接粘贴链接会自动转化为播放器，其他平台需转换为iframe标签，不会用请查阅置顶）\n','').replaceAll('# 😱正文请放二楼！！！\n','');   
        }




        return data;

     }); */


     
      
     override(DiscussionComposer.prototype, 'onsubmit', function (original,vnode) {
      this.loading = true;
     console.log('=======准备发帖=====', this)
      const data = this.data();
      if(data.content.length>2000){
        alert('长度超限。请不要把正文放在首楼！')
        data.title=''
        data.content=''
      }else{
        data.content= data.content.replace(/>!温馨提示[\s\S]*?(?:\r?\n\r?\n|$)/g, '');

      }
      console.log('=======即将发送=====', data.content)
      app.store
        .createRecord('discussions')
        .save(data)
        .then((discussion) => {
          this.composer.hide();
          app.discussions.refresh();
          m.route.set(app.route.discussion(discussion));
        }, this.loaded.bind(this));
    })
          
          
     
    //--------------------------提醒 增加最大化和读取更多按钮--------------------------
       extend(NotificationList.prototype, 'oncreate', function () {
           
               if(m.route.get()=='/notifications'){window.routeBeforeNotifications='index'}else{
              window.routeBeforeNotifications=m.route.get();
             }
           
       })
       
       
     extend(NotificationList.prototype, 'controlItems', function (items) {
             
         items.add(
          'expand',
          <Button
            className="Button Button--link"
            icon="fas fa-expand"
            title='展开'
            onclick={()=>{
            window.routeBeforeNotifications=m.route.get()
            m.route.set('/notifications' )

            }}
          />,
          70
        );
     
         
          items.add(
          'minimize',
          <Button
            className="Button Button--link"
            icon="fas fa-times"
            title='收起'
            onclick={()=>{
            m.route.set( window.routeBeforeNotifications)
            }}
          />,
          70
        );
        
         
         return items;
     }); 
   
   
   
   
    override(NotificationList.prototype, 'view', function (original,vnode) {
        const state = this.attrs.state;
        let loadButton=Button.component(
                {
                  className: 'Button'+ (state.hasNext()?' ':' noclick'),
                  onclick: ()=>{if (state.hasNext() && !state.isLoadingNext()) {
                                state.loadNext();
                          }
                  },
                },
                app.translator.trans(state.hasNext()?'core.forum.discussion_list.load_more_button':'没有更多了')
          )
          
          
        return (
      
          <div className="NotificationList">
            <div className="NotificationList-header">
              <h4 className="App-titleControl App-titleControl--text">{app.translator.trans('core.forum.notifications.title')}</h4>
    
              <div className="App-primaryControl">{this.controlItems().toArray()}</div>
            </div>
    
            <div className="NotificationList-content">{
            this.content(state)
                
            }</div>
            
           {loadButton}
          </div>
          
          
        );

     }); 


     //--------------------------Banner，取消掉banner可隐藏的选项--------------------------
   
    override(WelcomeHero.prototype, 'view', function (original,vnode) {
          
          //if (this.isHidden()) return null;

            //const slideUp = () => {
            //  this.$().slideUp(this.hide.bind(this));
            //};
            //  if (this.isHidden()) return null;
            //这里把原来的判断是否隐藏去掉了


            return (
              <header class="Hero WelcomeHero">
                <div class="container">
                
                  <div class="containerNarrow">
                    <h2 class="Hero-title">{app.forum.attribute('welcomeTitle')}</h2>
                    <div class="Hero-subtitle">{m.trust(app.forum.attribute('welcomeMessage'))}</div>
                  </div>
                </div>
              </header>
            );

     }); 




      if(window.isPC){
                
 
      
         extend(WelcomeHero.prototype, 'view', function (item) {      
          //   console.log("hero update")
           if(window.godLightInit){ 
               


               if(!window.godLightBox ){
                   window.godLightBox=window.godLightInit();
                   let d = document.querySelector(".WelcomeHero");
                   if(d){d.appendChild(godLightBox );}
                   window.godLightAnimate.bind(window.godLightThis)();

               }else if(!window.godLightBox.clientHeight){
                   let d = document.querySelector(".WelcomeHero");
                   if(d){d.appendChild(godLightBox );}
                   
               }
               
               
           }else if (!window.godLightScript){
                              {      
                  let heroFunc=()=>{
                    let s = document.createElement( 'script' );
                    s.async='true';
                    s.src="/assets/customized/godLight.js ";
                    s.type="module";
                    window.godLightScript=s;
                    document.querySelector("head").appendChild( s);
                    
                  
                  }   
                  if(document.readyState === 'complete'){
                    heroFunc();
                  }else{
                    window.addEventListener('load', heroFunc);
                  }
        
                }
           }

        })
      }
 
   
   
   //--------------------------post角标排版，调换action和footer的顺序--------------------------
   //最好改写， 用extend + 数组处理来解决，以后再说

   /*
   override(Post.prototype, 'view', function (original,vnode) {
    const attrs = this.elementAttrs();

    attrs.className = this.classes(attrs.className).join(' ');

    const controls = PostControls.controls(this.attrs.post, this).toArray();
    const footerItems = this.footerItems().toArray();
    

    return (
      <article {...attrs}>
        <div>
          {this.loading ? <LoadingIndicator /> : this.content()}
          <div class='Post-controls-customized'>
          
          <footer className="Post-footer">{footerItems.length ? <ul>{listItems(footerItems)}</ul> : null}</footer>
          
          <aside className="Post-actions">
            <ul>
              {listItems(this.actionItems().toArray())}
              {controls.length ? (
                <li>
                  <Dropdown
                    className="Post-controls"
                    buttonClassName="Button Button--icon Button--flat"
                    menuClassName="Dropdown-menu--right"
                    icon="fas fa-ellipsis-h"
                    onshow={() => this.$('.Post-controls').addClass('open')}
                    onhide={() => this.$('.Post-controls').removeClass('open')}
                    accessibleToggleLabel={app.translator.trans('core.forum.post_controls.toggle_dropdown_accessible_label')}
                  >
                    {controls}
                  </Dropdown>
                </li>
              ) : (
                ''
              )}
            </ul>
          </aside>
          
          
          </div>
          
        </div>
      </article>
    );

  
  
   });*/
   
//重写上一段，工地

   extend(Post.prototype, 'view', function (items) {
    
   //console.log("帖子角标")
    //console.log(items)
   return items;

   })


   
  /////-----------改一下帖子列表的标签，阻止ios自带样式-----------
     extend( DiscussionListItem.prototype, 'view', function (item) {
         item.children[2].children[2].tag='div';
        
         item.children[2].children[2].attrs.onclick=()=>{
             
             m.route.set(item.children[2].children[2]?.attrs?.href)
         }

     })
     
     
     
     //---------改一下帖子头部各种标签的顺序，改变一下回复数的位置-----------
        // 1. 从 contentItems 中移除
        extend(DiscussionListItem.prototype, 'contentItems', function (items) {
          items.remove('replyCount');
        });
        
        // 2. 添加到 mainItems 的头部
        extend(DiscussionListItem.prototype, 'infoItems', function (items) {
              // 原 title 的优先级是 100，这里设置 110 即可将 replyCount 放在最前面 (相当于 unshift)
              // 通过 this.replyCountItem() 直接获取节点，避免全局变量污染
              items.add('replyCount', this.replyCountItem(), 10);
              //console.log('测试是否存在',items?.has,items?.setPriority)
             if (items?.has('tags') && items?.setPriority) {
                  //console.log('====tags存在===')
                // 数字越大，排序越靠前
                items.setPriority('tags', 200); 
              }
          // console.log('------------尝试覆写mainItems--------');
          //console.log(items.toArray()); // 如果需要打印，需要调用 toArray()
        });
        
        //动态获取元素宽高，赋值给css变量
        (()=>{
            
            extend(DiscussionListItem.prototype, 'oncreate', function (out, vnode) {
    const dom = vnode.dom;
    const parent = dom && dom.parentNode;

    if (!parent) return;

    // 记录上一次的值，阻断无意义的 DOM 操作和死循环
    let lastW = -1;
    let lastH = -1;

    this.sizeObserver = new ResizeObserver(() => {
      const selfW = Math.floor(dom.offsetWidth / 10);
      const selfH = Math.floor(dom.offsetHeight / 10);

      // 仅在计算结果改变时才更新父节点
      if (selfW !== lastW || selfH !== lastH) {
        lastW = selfW;
        lastH = selfH;
        parent.style.setProperty('--selfW', selfW);
        parent.style.setProperty('--selfH', selfH);
      }
    });

    this.sizeObserver.observe(dom);
  });

  extend(DiscussionListItem.prototype, 'onremove', function () {
    if (this.sizeObserver) {
      this.sizeObserver.disconnect();
      this.sizeObserver = null;
    }
  });
        })()
        const FileManagerModal = flarum.extensions['fof-upload'].components.FileManagerModal;
        (()=>{
          if (!FileManagerModal) return; // 
          override(FileManagerModal.prototype, 'sharedFilesContent', (original)=>{
              //console.log('FileManagerModalThis',this,this.sharedFileState.files,this?.dom?.querySelectorAll('img'))
           // console.log('FileManagerModalThis',this,this.sharedFileState.files,this?.dom?.querySelectorAll('img'))
           //  console.log( 'sharedFilesContent',item.state.fileState.files)
           let item= original()
         // console.log('item',original(), item?.attrs,item?.attrs.fileState?.files)
          // console.log('original',original)
          
            if(item?.attrs?.fileState?.files){item.attrs.fileState.files = 
            item.attrs.fileState.files.map(file => {
                /*
                console.log(
                    'file',
                    file?.data?.attributes,
                    file?.data?.attributes?.url,
                    
                    file?.data?.attributes?.url?.includes)*/
                  if (
                      file?.data?.attributes?.url
                      && file?.data?.attributes?.url?.includes
                      && !file?.data?.attributes?.url?.includes('.small.')
                  
                  ) {
                     
                    // 仅针对 jpg, jpeg, png 进行 .small 注入替换
                    file.data.attributes.url = file.data.attributes.url.replace(/(\.(?:jpg|jpeg|png))(\?.*)?$/i, '.small$1$2');
                  }
                  return file;
                });
            // console.log(item.attrs.fileState.files)
                
            }
            return item;
        })
               
        })()
        
        
        let Excerpt=flarum.extensions['fof-synopsis'].components.Excerpt;
        
        (()=>{if (!Excerpt) return;

      override(Excerpt.prototype, 'contentRich', function (original) {
            const html = original();
            if (!html) return html;
        
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
        
            // --- 0. 提前判断状态 (提取图片前) ---
            const hasImg = doc.querySelectorAll('img:not(.emoji):not(.Avatar):not(.flaemoji-customized)').length > 0;
        
            // --- 1. 严格复刻图片排除逻辑 ---
            const elements1 = Array.from(doc.querySelectorAll('img:not([data-src]):not([is-preview]):not([isfancy]):not(.emoji):not(.Avatar):not(.flaemoji-customized):not([data-reaction]):not([data-link-preview])'));
            const elements2 = Array.from(doc.querySelectorAll(':is(blockquote,details,.bbspoiler-blur,.chatroom,.no-fancybox) img:not(.emoji):not(.Avatar):not(.flaemoji-customized):not([data-reaction]):not([data-link-preview]), .editing img'));
            
            const images = elements1.filter(img => !elements2.includes(img));
            images.forEach(img => img.remove());
            const imgCount = images.length;
        
            // --- 2. 判断剩余内容是否为空骨架 ---
            const rawText = doc.body.textContent.trim();
            const hasMedia = doc.body.querySelectorAll('img, video, audio, iframe, svg, canvas').length > 0;
            const isNonText = rawText === '' && !hasMedia;
        
            // --- 3. 【新增】创建最外层包裹容器 ---
            const masterContainer = doc.createElement('div');
            let masterClasses = ['synopsis-container'];
            if (hasImg) masterClasses.push('hasImg');
            if (isNonText) masterClasses.push('nonText');
            masterContainer.className = masterClasses.join(' ');
        
            // --- 4. 组装富文本容器 ---
            const richTextContainer = doc.createElement('div');
            richTextContainer.className = 'synopsis-rich-text-container';
        
            // 此时 body 里面剩下的节点全部转移到富文本容器里
            while (doc.body.firstChild) {
                richTextContainer.appendChild(doc.body.firstChild);
            }
            
            // 把富文本容器装进最外层容器
            masterContainer.appendChild(richTextContainer);
        
            // --- 5. 组装轮播容器 ---
            if (imgCount > 0) {
                const container = doc.createElement('div');
                container.className = `synopsis-carousel-container ${imgCount === 1 ? 'has-single-image' : 'has-multi-images'}`;
                container.style.aspectRatio = '1 / 1'; 
        
                if (imgCount > 1) {
                    const counter = doc.createElement('span');
                    counter.className = 'synopsis-carousel-counter';
                    counter.textContent = `${imgCount}`;
                    container.appendChild(counter);
        
                    const DURATION_PER_IMG = 2;
                    const TRANSITION_DURATION = 0.5;
                    const totalDuration = imgCount * DURATION_PER_IMG;
                    let keyframeCSS = '';
                    for (let i = 0; i < imgCount - 1; i++) {
                        const animName = `slideshow-count-${imgCount}-idx-${i}`;
                        const p1 = (i === 0) ? ((DURATION_PER_IMG - TRANSITION_DURATION) / totalDuration * 100).toFixed(2) : (((i + 1) * DURATION_PER_IMG - TRANSITION_DURATION) / totalDuration * 100).toFixed(2);
                        const p2 = (i === 0) ? (DURATION_PER_IMG / totalDuration * 100).toFixed(2) : (((i + 1) * DURATION_PER_IMG) / totalDuration * 100).toFixed(2);
                        const p3 = (i === 0) ? ((totalDuration - TRANSITION_DURATION) / totalDuration * 100).toFixed(2) : 99.9;
                        keyframeCSS += `@keyframes ${animName} { 0%, ${p1}% { opacity: 1; } ${p2}%, ${p3}% { opacity: 0; } 100% { opacity: 1; } } `;
                    }
                    const styleTag = doc.createElement('style');
                    styleTag.textContent = keyframeCSS;
                    container.appendChild(styleTag);
        
                    const reversedImages = [...images].reverse();
                    reversedImages.forEach((img, idx) => {
                        const originalIndex = images.indexOf(img);
                        const isBottom = originalIndex === imgCount - 1;
                        const newImg = doc.createElement('img');
                        newImg.className = 'synopsis-carousel-img';
                        let imgSrc = img.src;
                        if (!imgSrc.includes('.small.') && !imgSrc.includes('.medium.')) {
                            imgSrc = imgSrc.replace(/(\.jpg|\.png)$/i, '.medium$1');// isPC() ? '.medium$1' : '.small$1'
                        }
                        newImg.src = imgSrc;
                        if (!isBottom) {
                            newImg.style.animation = `slideshow-count-${imgCount}-idx-${originalIndex} ${totalDuration}s infinite linear`;
                        }
                        container.appendChild(newImg);
                    });
                } else {
                    const singleImg = doc.createElement('img');
                    singleImg.className = 'synopsis-carousel-img';
                    let imgSrc = images[0].src;
                    if (!imgSrc.includes('.small.') && !imgSrc.includes('.medium.')) {
                        imgSrc = imgSrc.replace(/(\.jpg|\.png)$/i,'.medium$1' );//isPC() ? '.medium$1' : '.small$1'
                    }
                    singleImg.src = imgSrc;
                    container.appendChild(singleImg);
                }
        
                // 把轮播容器也装进最外层容器（排在富文本后面）
                masterContainer.appendChild(container);
            }
        
            // --- 6. 最终输出 ---
            doc.body.appendChild(masterContainer);
            return doc.body.innerHTML;
        });
        
        
        
        
        //===================帖子引用的字数限制=======================
        
        const MAX_CHARS = 300; // 在这里设置你的最大字数限制

          // 1. 拦截向前/向左选中时的显示逻辑
          override(PostQuoteButton.prototype, 'showStart', function (original, x, y) {
            if (this.content && this.content.length > MAX_CHARS) {
              // 如果超长，给用户一个友好的弹窗提示，并拦截显示
              app.alerts.show({ type: 'warning' }, `引用的文本不能超过 ${MAX_CHARS} 个字符！`);
              return; 
            }
            
            // 如果没有超长，正常执行原有的显示和定位逻辑
            return original(x, y);
          });
        
          // 2. 拦截向后/向右选中时的显示逻辑
          override(PostQuoteButton.prototype, 'showEnd', function (original, x, y) {
            if (this.content && this.content.length > MAX_CHARS) {
              // 这里不需要重复弹窗，因为鼠标松开时只会触发 showStart 或 showEnd 其中之一
              // 如果为了双重保险也可以加上弹窗，但通常直接 return 静默拦截即可
              app.alerts.show({ type: 'warning' }, `引用的文本不能超过 ${MAX_CHARS} 个字符！`);
              return;
            }
            
            return original(x, y);
          });
          extend(PostQuoteButton.prototype, 'render', function (vnode) {
            // 1. 确保有选中的文本内容，且虚拟 DOM 结构正常
            if (!this.content || !vnode || !vnode.children) return;
        
            // 2. Flarum 按钮的文字通常包裹在 class 为 'Button-label' 的 span 中
            // 我们遍历它的 children 找到这个节点
            const labelNode = vnode.children.find(
              (child) => child && child.attrs && child.attrs.className === 'Button-label'
            );
        
            if (labelNode) {
              const currentLength = this.content.length;
              
              // 3. 拼接要显示的字数统计，比如： " (15/200)"
              const countText = ` (${currentLength}/${MAX_CHARS})`;
        
              // 4. 安全地将文字追加到 Mithril 的 children 中
              // Mithril 的 children 可能是单个字符串、对象或数组，稳妥起见统一转为数组形式
              if (Array.isArray(labelNode.children)) {
                labelNode.children.push(countText);
              } else {
                labelNode.children = [labelNode.children, countText];
              }
        
              // 5. 【可选体验优化】如果字数超标，将统计文字变成红色，给用户强烈的视觉暗示
              if (currentLength > MAX_CHARS) {
                // 合并原有的 style 属性
                labelNode.attrs.style = Object.assign(labelNode.attrs.style || {}, {
                  color: '#e74c3c', // 红色警告
                  fontWeight: 'bold'
                });
              }
            }
          });
        
    extend(Excerpt.prototype, 'oncreate', function (out, vnode) {
    const dom = this.element || (vnode && vnode.dom);
    const container = dom?.querySelector('.synopsis-carousel-container');
    if (!container) return;

    const carouselImages = Array.from(container.querySelectorAll('img.synopsis-carousel-img'));
    const imgCount = carouselImages.length;

    let loadedCount = 0;
    let hasFlat = false;   // 是否存在扁图 (>1:1)
    let hasLong = false;   // 是否存在长图 (<1:1)
    let maxRatio = 0;      // 扁图中最小的比例 (最接近 1:1)
    let minRatio = 999;    // 长图中最大的比例 (最接近 1:1)
    let maxW = 0, minW = Infinity;
    let maxH = 0, minH = Infinity;
    
    const updateLayout = () => {
      if (loadedCount < imgCount) return;

      let finalRatio = 1;

      if (hasFlat && hasLong) {
        // 既有扁又有长，强制 1:1
        finalRatio = 1;
      } else if (hasFlat) {
        // 全是扁图，取最接近 1:1 的那张（即 ratio 最小的那张），极限 4:1
        finalRatio = Math.min(maxRatio, 4);
      } else if (hasLong) {
        // 全是长图，取最接近 1:1 的那张（即 ratio 最大的那张），极限 3:4
        finalRatio = Math.max(minRatio, 0.75);
      }

      container.style.aspectRatio = `${finalRatio} / 1`;
      // 触发你之前的扁图 class 逻辑
      if (finalRatio > 4 / 3) container.classList.add('is-flat-img');
      // 2. --- 注入四个维度的 CSS 变量 ---
      container.style.setProperty('--max-w', `${maxW}px`);
      container.style.setProperty('--min-w', `${minW === Infinity ? 0 : minW}px`);
      container.style.setProperty('--max-h', `${maxH}px`);
      container.style.setProperty('--min-h', `${minH === Infinity ? 0 : minH}px`);
    };

    carouselImages.forEach(img => {
      const process = () => {
        loadedCount++;
        if (img.naturalWidth && img.naturalHeight) {
          const w = img.naturalWidth;
          const h = img.naturalHeight;
          const r = img.naturalWidth / img.naturalHeight;
          if (r > 1) {
            hasFlat = true;
            if (maxRatio === 0 || r < maxRatio) maxRatio = r;
          } else if (r < 1) {
            hasLong = true;
            if (minRatio === 999 || r > minRatio) minRatio = r;
          }
          // --- 宽高独立统计 ---
          if (w > maxW) maxW = w;
          if (w < minW) minW = w;
          if (h > maxH) maxH = h;
          if (h < minH) minH = h;
        }
        updateLayout();
      };

      // 替换掉原来的 if/else 逻辑
      if (img.complete) {
        if (img.naturalWidth === 0) {
          // 已经加载完成，但是一张死图（宽为0）
          img.removeAttribute('src'); // 1. 物理拔网线，防止后续滚动反复触发请求
          loadedCount++;              // 2. 手动计入已处理数量
          updateLayout();             // 3. 触发后续布局计算
        } else {
          // 已经加载完成，且是正常图片
          process();
        }
      } else {
        // 还没加载完成，正常挂载单次监听器
        img.addEventListener('load', process, { once: true });
        img.addEventListener('error', () => { 
          img.removeAttribute('src'); // 物理拔网线
          loadedCount++; 
          updateLayout(); 
        }, { once: true });
      }
    });
  });  }
        
        )()

            
    if (app.data['fof-nightmode.assets.day']) {
         app.data['fof-nightmode.assets.day'] =  app.data['fof-nightmode.assets.day'].replace(window.location.origin,app.cdnHost);
    }
    if (app.data['fof-nightmode.assets.night']) {
        app.data['fof-nightmode.assets.night'] =  app.data['fof-nightmode.assets.night'].replace(window.location.origin,app.cdnHost);
    }
   //win版帖子控件随着scroll改变样式 
      /*
      if (!window.matchMedia("only screen and (max-width: 1100px)").matches) {
      extend(DiscussionPage.prototype, 'oncreate', function (vnode) {
       
          $(window).on('scroll', function (e) {
            const nav = $('.DiscussionPage-nav').children();
           
            if ($(window).scrollTop() > document.querySelector(".Hero").clientHeight) {
              nav.addClass('websocket-nav');
            } else {
              nav.css('position', 'absolute');
              nav.removeClass('websocket-nav');
              
                }
              })
            
          });
          
      }*/



     //------添加一部分延迟加载的脚本，属于原来的页脚




    
        // 核心逻辑保持简洁
    function updateHeaderStatus() {
        const aapp = document.querySelector("#app");
        const hero = document.querySelector('.Hero');
        const header = document.querySelector("header#header");
    
        if (!header || !aapp) return;
    
        // 如果当前页面根本没 Hero，直接移除 top 状态，设为 Body 模式
        if (!hero) {
            header.classList.remove("header-onTop");
            aapp.classList.add("viewing-Body");
            return;
        }
    
        const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
        const heroBottom = hero.getBoundingClientRect().bottom;
        const isAtTop = heroBottom > headerHeight;
    
        header.classList.toggle("header-onTop", isAtTop);
        aapp.classList.toggle("viewing-Body", !isAtTop);
}

       
    // 2. 绑定事件（带节流优化，防止滚动时过度计算）
    let isTickingscroll = false;
    window.addEventListener('scroll', () => {
        if (!isTickingscroll) {
            window.requestAnimationFrame(() => {
                updateHeaderStatus();
               isTickingscroll = false;
            });
            isTickingscroll = true;
        }
    }, { passive: true });
    
    // 2. 适配 Flarum SPA：监听 URL 变化
    // Flarum 切换路由时会触发 popstate (后退) 或由应用内部触发 pushState
    window.addEventListener('popstate', updateHeaderStatus);
    
    // 3. 适配 Flarum DOM 重写：使用 MutationObserver
    // 当 #app 内部结构发生剧变（比如进入新帖子、返回首页）时自动触发
    const observer = new MutationObserver(() => {
        updateHeaderStatus();
    });
    
    const appTarget = document.querySelector('#app') || document.body;
    observer.observe(appTarget, {
        childList: true, // 观察子节点增删
        subtree: true    // 深度观察，确保内部 Hero 挂载时能捕获
    });
    
    // 4. 初始化执行
    updateHeaderStatus();






      // 动态加载
      var emojiButton = document.createElement('script');
      emojiButton.src =  app.cdnHost+'/the-turk-flamoji/dist/vendors~emoji-button-message-zh.js ';
      emojiButton.async="true"
      emojiButton.defer="true"
      document.head.appendChild(emojiButton);

      var animateCSS = document.createElement('link');
      animateCSS.rel = 'stylesheet';
      animateCSS.href = app.cdnHost+'/assets/customized/animate.css';
      animateCSS.async="true"
      animateCSS.defer="true"
      document.head.appendChild(animateCSS);
  
      var cssShake = document.createElement('link');
      cssShake.rel = 'stylesheet';
      cssShake.href =  app.cdnHost+'/assets/customized/csshake.css';
      cssShake.async="true"
      cssShake.defer="true"
      document.head.appendChild(cssShake);


     //------以下是我站特色装饰
     /*
     if(window.location.host.indexOf('gzszd')!=-1){
            window.addEventListener('load', function() {

              var jq=document.createElement('script');
                    jq.src = 'https://libs.baidu.com/jquery/2.1.1/jquery.min.js';
                  document.head.appendChild(jq);
                    var fish = document.createElement('script');
                  fish.src = "//"+app.cdnHost+`/assets/customized/fish.js`;
                  document.head.appendChild(fish);
                    fish.defer=true;
                    fish.async=true;
                    // 动态添加HTML结构
        
              var decoration = document.createElement('div');
              decoration.innerHTML= `
                <!-- 漂亮的背景 -->
                <div>
                  <img src="//gzszd.icu/assets/customized/img/shan.png" style="pointer-events:none;width:20%;max-width: 150px;height: 450px;margin-top: -350px;position: absolute;z-index:3;right: 0%;" class="shan" loading="lazy" />
                  <div style="pointer-events:none; animation: breath 10s infinite; position: relative; z-index: 3;">
                      <img src="//gzszd.icu/assets/customized/img/qyg.png" style="width:15%;max-width: 120px;margin-top: -320px;position: absolute;z-index:3;right: 15%;-webkit-animation: shakeY 99s infinite;" class="qyg" loading="lazy" />
                  </div>
        
                  <div style="pointer-events:none; animation: breath 30s infinite; position: relative; z-index: 3;" class='yuntao'>
                      <div style="animation: heartBeat 100s infinite;">
                          <img src="//gzszd.icu/assets/customized/img/yun.png" loading="lazy" style="opacity:0.5;width:80%;max-width: 400px;margin-top: -280px;position: absolute;z-index:3;right: -40px;animation: shakeX 20s infinite;" class="yun" />
                      </div>
                  </div>
                </div>
              `
              document.body.appendChild(decoration) 
        
            })
        
       
        
        
        
        
        
            window.addEventListener('DOMContentLoaded', function() {
        

        
              //--------------这里开始是注入暗号--------------
        
                  console.log("-----------注入暗号-----------")
        
                  function numberToMorse(number) {
                    //密码本
                    const morseCodeMapping = {
                      '0': ' ∅◇-  ',
                      '1': '  -∅◇ ',
                      '2': ' ∅ -◇ ',
                      '3': ' ∅◇ ∅ ',
                      '4': ' ∅ ∅◇ ',
                      '5': ' ∅◇◇ ',
                      '6': ' ◇ -- ',
                      '7': ' - ◇- ',
                      '8': ' --  ◇',
                      '9': ' ◇◇◇'
                    };
              
                    return number.toString().split('').map(digit => morseCodeMapping[digit]).join('|');
                  }
              
                  function setMorseCodeBackground(number) {
                    const morseCode = numberToMorse(number);
                    app.session.user.data.morseCode=morseCode;
                    const svgContent = `<svg xmlns="http://www.w3.org/2000/svg" width="fit-content" height="1.7em">
                                          <text x="10" y="20" font-family="monospace" font-size="1em">${morseCode+'♡'}</text>
                                        </svg>`;
                    const encodedSVG = encodeURIComponent(svgContent).replace(/%3D/g, '=').replace(/%3A/g, ':').replace(/%2F/g, '/');  
                  document.documentElement.style.setProperty('--morse-code-background', `url("data:image/svg+xml,${encodedSVG}")`);
                
                  document.documentElement.style.setProperty('--morse-length', ''+ (morseCode+'||').length);
                }
          
                  // Call the function with the desired number
                  if(app?.session?.user?.data?.id){
                      setMorseCodeBackground(app.session.user.data.id);
                  }
        
        
                  //--------------这里开始是注入桌宠--------------
                  app.randomIframe = Math.random();
                  var div = document.createElement('div');
                  div.className = 'pet';
                  div.innerHTML = `
                    <iframe loading="lazy" class="petFrame" allowtransparency="true" src=""></iframe>
                    <button class="petClose fas fa-times"></button>
                  `;
        
                  if ( app.randomIframe > 0.5) {
                        div.querySelector("iframe").setAttribute("src", "//"+app.cdnHost+"/assets/l2d-4/Zhongli.html");
                        console.log("第一个桌宠zl")
                      }else{
                        div.querySelector("iframe").setAttribute("src","//"+app.cdnHost+"/assets/l2d-4/Tartaglia.html");
                        console.log("第一个桌宠ddly")
                  }
                  document.body.appendChild(div);
                  // Handle the click event on the close button
                  var closeButton = div.querySelector('.petClose');
                  closeButton.addEventListener('click', function() {
                    div.remove(); // This will remove the .pet element from the DOM
                  });
        
              console.log("-----------加载了第一个桌宠-----------")
              
               
              var welcomeHero = document.querySelector('.Hero.WelcomeHero');
        
                  if(window.isPC  && welcomeHero){
                          var div2 = document.createElement('div');
                          div2.className = 'pet';
                          div2.innerHTML = `
                              <iframe loading="lazy" class="petFrame" allowtransparency="true" src=""></iframe>
                          `;
                         
                          // 设置第二个 iframe 的 src
                          if ( app.randomIframe> 0.5) {
                        console.log("第二个桌宠ddly")
                              div2.querySelector("iframe").setAttribute("src","//"+ app.cdnHost+"/assets/l2d-4/Tartaglia.html");
                                    
                                    }else{
                              div2.querySelector("iframe").setAttribute("src","//"+ app.cdnHost+"/assets/l2d-4/Zhongli.html");
        
                        console.log("第二个桌宠zl")
                            }
                                    // Add the second pet to a specific element
                          
                          if (welcomeHero) {
                              welcomeHero.appendChild(div2);
                          }
                  }
        
            })


     }

    */


},-99999);
